import React from 'react'
import { useSelector } from 'react-redux'

import { Text, Main } from '../../../components'
import { getOrganization } from './state'
import { FormattedMessage } from 'react-intl'

export function EmailSent() {
  const organization = useSelector(getOrganization)
  return (
    <Main.Container>
      <Main.Title>
        <FormattedMessage
          id="boarding.organization.join.emailSent.title"
          defaultMessage="You’re already invited to join {organizationName}"
          values={{ organizationName: organization.name }}
        />
        {organization.name}
      </Main.Title>
      <Text.Corpus style={{ lineHeight: '1.8em' }}>
        <span className="font-weight-medium">
          <FormattedMessage
            id="boarding.organization.join.emailSent.description"
            defaultMessage="Search for the invite in your emails to accept it."
            values={{}}
          />
          <br />
        </span>
        <FormattedMessage
          id="boarding.organization.join.emailSent.description2"
          defaultMessage="Can't find it? Ask someone in {organizationName} to send over another
        invite!"
          values={{ organizationName: organization.name }}
        />
      </Text.Corpus>
    </Main.Container>
  )
}
